import { useSelector } from 'react-redux';
import { Divider, FormControl, FormControlLabel, FormLabel, IconButton, Paper, Radio, RadioGroup, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import { FaArrowCircleLeft } from 'react-icons/fa'
import { selectCapacitacionesPeriodoActivo, selectTiposCapacitaciones } from '../../../../redux/Capacitaciones/CapacitacionesSlice';
import { Controller, useFormContext, useFormState, useWatch } from 'react-hook-form';
import CreatableSelect from 'react-select/creatable';
import Select from "react-select";
import { IoMdAddCircle } from 'react-icons/io';
import { BiSave } from 'react-icons/bi';
import { MdDeleteForever, MdModeEdit } from 'react-icons/md';
import { colors } from '../../../../utils/colors';
import { trimestres } from '../../../../utils/enums/trimestres';

export const PaginaRegistroCapacitaciones = ( 
  { 
    stepPosition, 
    setStepPosition, 
    capacitacionesState, 
    funcAgregarNuevaCapacitacion,
    funcSaveData,
    funcDeleteEmpleado,
    setOpen,
    meses = []
  } ) => {

  // ? HOOK-SELECTOR
  const tiposCapacitaciones = useSelector(selectTiposCapacitaciones);

  // ? HOOK-FORM
  const { control, watch, handleSubmit } = useFormContext();

  // * OBTENER Y PERMANECER ERRORES PARA EVITAR ERRORES DE RENDERIZADO.
  const { errors } = useFormState({
    control,
    name: ['capacitacion.tipoId', 'servidorDetallesHabilidades', 'reflejosColaboradorCapacitacion'],
  });

  // ? HOOK-WATCH
  const empleadosWatch = useWatch({
    control,
    name: 'empleados',
    defaultValue: [],
  })

  return (
  <form id='formCapacitacion' onSubmit={handleSubmit(funcSaveData)} >
    <Paper>
      <Stack p={2}>

          <Typography fontSize={22}>
            Capacitaciones
          </Typography>
          <Divider />
        
          <Stack mt={2}>
            <Stack>
              <Typography fontWeight='bold'>Capacitación</Typography>
              <Controller
              control={control}
              name="capacitacion"
              render={({ field}) => (
               <>
                 <CreatableSelect 
                  defaultValue={{}}
                  placeholder='Seleccionar Capacitación'
                  onCreateOption={(e) => funcAgregarNuevaCapacitacion({ descripcion: e})}
                  isClearable 
                  options={capacitacionesState ?? []}
                  getOptionLabel={(option) => option.descripcion}
                  getOptionValue={(option) => option.id}
                  onChange={(opt, actionMeta) => {   
                    if (actionMeta?.action === 'clear' || opt == null) {
                      field.onChange(0);
                    } else {      
                      field.onChange({...opt, nuevo: opt?.nuevo ? true: false});
                    }
                  }}
                  value={capacitacionesState.find(x => x.id === field.value?.id) ?? {}}
                  />
               </>
              )}
              />

              <p className='text-danger mb-0' hidden={!errors?.capacitacion?.id?.message}>{errors?.capacitacion?.id?.message}</p>
            </Stack>

            <Stack component='div' mt={2} hidden={!watch('capacitacion.nuevo')}>
              <Typography fontWeight='bold'>Tipo</Typography>
              <Controller
              control={control}
              name="capacitacion.tipoId"
              render={({ field, fieldState: { error } }) => (
                <>
                  <Select
                  classNamePrefix="select"
                  isSearchable={true}
                  placeholder="Seleccionar Tipo"
                  options={tiposCapacitaciones}
                  getOptionLabel={(option) => option.descripcion}
                  getOptionValue={(option) => option.id}
                  onChange={(e) => field.onChange(e.id)}
                  value={tiposCapacitaciones.find(x => x.id === field.value)}
                  />
                </>
              )}
              />

              <p className='text-danger mb-0' hidden={!errors?.capacitacion?.tipoId?.message}>{errors?.capacitacion?.tipoId?.message}</p>
            </Stack>

            <Stack component='div' mt={1}>
              <Typography fontWeight='bold'>El Servidor conoce las habilidades y conocimientos de su cargo</Typography>
              <Controller
              name="servidorDetallesHabilidades"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={field.value}
                    onChange={field.onChange}
                  >
                    <FormControlLabel value={true} control={<Radio />} label="Si" />
                    <FormControlLabel value={false} control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
              )}
              />

              <p className='text-danger mb-0' hidden={!errors?.servidorDetallesHabilidades?.message}>{errors?.servidorDetallesHabilidades?.message}</p>
            </Stack>

            <Stack component='div' mt={1}>
              <Typography fontWeight='bold'>¿Qué debe reflejar el colaborador luego de tomar la capacitación?</Typography>
              <Controller
              name="reflejosColaboradorCapacitacion"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  value={field.value ?? ''}
                  onChange={(e) => field.onChange(e.target.value)}
                  onBlur={(e) => field.onChange(e.target.value?.trim() ?? '')} // opcional
                  label=" "
                  variant="outlined"
                  fullWidth
                  error={!!error}
                />
              )}
              />

              <p className='text-danger mb-0' hidden={!errors?.reflejosColaboradorCapacitacion?.message}>{errors?.reflejosColaboradorCapacitacion?.message}</p>
            </Stack>

            <Stack component='div' mt={2}>
              <Typography fontWeight='bold'>Trimestre</Typography>
              <Controller
              control={control}
              name="trimestre"
              render={({ field, fieldState: { error } }) => (
                <>
                  <Select
                  classNamePrefix="select"
                  isSearchable={true}
                  placeholder="Seleccionar Trimestre"
                  options={trimestres}
                  getOptionLabel={(option) => option.nombre}
                  getOptionValue={(option) => option.id}
                  onChange={(e) => field.onChange(e.id)}
                  value={trimestres.find(x => x.id === field.value)}
                  />
                </>
              )}
              />

              <p className='text-danger mb-0' hidden={!errors?.trimestre?.message}>{errors?.trimestre?.message}</p>
            </Stack>

            <Stack component='div' mt={2}>
              <Typography fontWeight='bold'>Mes</Typography>
              <Controller
              control={control}
              name="mes"
              render={({ field, fieldState: { error } }) => (
                <>
                  <Select
                  classNamePrefix="select"
                  isSearchable={true}
                  placeholder="Seleccionar Mes"
                  options={meses}
                  getOptionLabel={(option) => option.nombre}
                  getOptionValue={(option) => option.noEntero}
                  onChange={(e) => field.onChange(e.noEntero)}
                  value={meses.find(x => x.noEntero === field.value)}
                  />
                </>
              )}
              />

              <p className='text-danger mb-0' hidden={!errors?.trimestre?.message}>{errors?.trimestre?.message}</p>
            </Stack>

            <Stack mt={2} mb={2}>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>Empleado</b>
                      </TableCell>
                      <TableCell>
                        <b>Grado</b>
                      </TableCell>
                      <TableCell>
                        <b>Nombre del Grado Obtenido</b>
                      </TableCell>
                      <TableCell align='right'>
                        <button onClick={() => setOpen({ open: true, edit: false, empleado: {}})} className='btn btn-primary-mem'>Agregar <IoMdAddCircle style={{marginBottom: 1}} fontSize={22} /></button>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                   {empleadosWatch.length > 0 ? 
                     empleadosWatch.map(({ empleado : item }, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            {item.nombreEmpleado}
                          </TableCell>
                          <TableCell>
                            {item?.tipo}
                          </TableCell>
                          <TableCell>
                            {item?.nombreGradoAlcanzado}
                          </TableCell>
                          <TableCell>
                            <IconButton onClick={() => setOpen({ open: true, edit: true, empleado: item})}>
                              <MdModeEdit color={colors.azulMem} fontSize={22} />
                            </IconButton>
                            <IconButton onClick={() => funcDeleteEmpleado(item)}>
                              <MdDeleteForever color='red' fontSize={22} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                      
                    :
                    <TableCell align='center' colSpan={4}>No hay registros</TableCell>
                  }
                  </TableBody>
                </Table>
              </TableContainer>
              
            </Stack>
          </Stack>




          <div className='d-flex justify-content-between'>
            <button type='button' onClick={() => setStepPosition(stepPosition - 1)} hidden={stepPosition !== 1} className='btn btn-primary-mem'>
              <FaArrowCircleLeft style={{marginBottom: 3}} /> Anterior
            </button>
            <button form='formCapacitacion' type='submit' className='btn btn-primary-mem'>
            Guardar <BiSave style={{marginBottom: 3}} fontSize={22} />
            </button>
          </div>
      </Stack>
    </Paper>
  </form>
  )
}
